import styled from '@emotion/styled';

import { StyleCollection } from '@/utils/types';
import Button from '../Buttons/Button';

const styles: StyleCollection = {
    button: {
        fontSize: '1.4rem',
        padding: '4px 6px',
        '&:hover': {
            backgroundColor: '#1b1c1ea7',
        },
    },
};

export const ToastMessage = styled.div`
    font-size: 1.6rem;
`;

const ToastMessageContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ToastMsg = ({ closeToast, message, buttonText, onButtonClick }: any) => {
    return (
        <ToastMessageContainer>
            {message && <ToastMessage>{message}</ToastMessage>}
            {buttonText && (
                <Button
                    onClick={() => {
                        closeToast();
                        onButtonClick();
                    }}
                    variant="outlined"
                    sx={styles.button}>
                    {buttonText}
                </Button>
            )}
        </ToastMessageContainer>
    );
};
